<template>
  <div>
    <div v-if="lat && lng">

<!--
      <center><a :href="'https://maps.googleapis.com/maps/api/directions/json?origin=null&destination=' + lat + ',' + lng + '&key=' + key"  target="_blank">Directions</a></center>
-->
      <gmap-map
        :ref="mapRef"
        :center="{lat: Number(localLat), lng:Number(localLng)}"
        :options="mapOptions"
        :zoom="zoom" :map-type-id="mapType"
        :style="'width:'+ this.width + '; height: ' + this.height"
        @mouseover="statusText = 'Hello There!'"
        @mouseout="statusText = null">

      <gmap-marker
        v-if="mapPosition"
        :position="mapPosition"
        :clickable="clickable"
        :draggable="!hasMarkers ? draggable : false"
        @dragend="updatePos"
        :icon="showNominal ? nominalMapPin() : defaultMapPin()"
        @click="center=mapPosition" />

      <template v-if="hasMarkers">

        <gmap-marker v-for="(m, i) in mrk" :key="i"
          :position="position(m.position)"
          :clickable="dragMarkers"
          :draggable="dragMarkers"
          @dragend="updateMarkerPos"
          :icon="m.icon ? m.icon : defaultMapPin()"
          @click="markerDrag(i)" />
      </template>

    </gmap-map>

<!--
<el-popover
  placement="top"
  width="160"
  v-model="visible">
  <p>Are you sure to delete this?</p>
  <div style="text-align: right; margin: 0">
    <el-button size="mini" type="text" @click="visible = false">cancel</el-button>
    <el-button type="primary" size="mini" @click="visible = false">confirm</el-button>
  </div>
  <template #reference><el-button>Delete</el-button></template>
</el-popover>
-->
    <el-row v-if="hasMarkers">

      <el-col v-if="canAdd" :span="24" align="center" style="padding-top: 0.528em; padding-bottom: 0.528em;">

        <el-button
          :type="adding ? 'success' : 'primary'"
          size="mini"
          icon="fa fa-map-marker"
          @click="toggleAdd">

          {{adding ? ' Add to Map' : ' Add Marker'}}

        </el-button>

      </el-col>

      <el-col :span="24" align="left">
        <el-collapse accordion v-model="item">

          <el-collapse-item v-if="adding" name="addMarker" :disabled="!adding">
            <template #title><i class="fa fa-map-marker-alt">&nbsp;</i>Add Marker</template>

            <el-form inline>
              <select-input v-if="optionMapPins" label="Pin" v-model="marker.icon" :list="optionMapPins" is-image-list />
              <select-input v-if="options" label="Type" v-model="marker.type" :list="options" :icon-list="optionIcons" />
              <text-input label="Title" v-model="marker.infoText" />
              <float-input label="Lat." v-model="marker.position.lat" :decimals="15" />
              <float-input label="Lng." v-model="marker.position.lng" :decimals="15" />
            </el-form>

          </el-collapse-item>



          <!-- Marker Table -->
          <el-collapse-item name="table" :disabled="!adding">
            <template #title><i class="fa fa-map-marked">&nbsp;</i>Markers</template>

            <el-table stripe :data="mrk">

              <el-table-column label="Name" width="396">
                <template #default="scope">
                  <img v-if="scope.row.icon" :src="scope.row.icon" style="height: 17.4px; width: auto;" />&nbsp;<span v-safe-html="scope.row.infoText" />
                </template>
              </el-table-column>

              <el-table-column prop="position.lat" label="Lat." class-name="hidden-md-and-down" />

              <el-table-column prop="position.lng" label="Lng." class-name="hidden-md-and-down" />

              <el-table-column label="Distance" width="174">
                <template #default="scope">
                  <b>
                    {{formatNumber(scope.row.distance > 0 ? scope.row.distance : distanceInKmBetween(mapPosition.lat, mapPosition.lng, scope.row.position.lat, scope.row.position.lng) * 1000, 2)}}m.
                    &nbsp;<i :class="typeIcon(scope.row.type)" />
                  </b>
                </template>
              </el-table-column>

              <el-table-column
                  v-if="deleteMarkers"
                  align="right">
                  <template #default="scope">
<!--
                    <el-button
                      size="mini"
                      type="primary"
                      icon="fa fa-edit"
                      circle
                      @click="handleEdit(scope.$index, scope.row)" />
-->
                    <el-button
                      size="mini"
                      type="danger"
                      icon="fa fa-trash"
                      circle
                      @click="handleDelete(scope.$index, scope.row)"
                      :disabled="scope.$index === 0" />

                  </template>
                </el-table-column>
            </el-table>

          </el-collapse-item>

        </el-collapse>
      </el-col>

<!--      <center>Distance between point 1 &amp; 2 = </center> -->
    </el-row>

    </div>
    <div v-else>
      <center><h4>No mapping data found</h4></center>
    </div>

  </div>
</template>

<script>

import Vue from 'vue'

import * as GMap from 'gmap-vue'

import {GOOGLE_API_KEY} from '@/components/Data'

import NumberMixins from '@/mixins/NumberMixins'


Vue.use(GMap, {
  load: {
    key: GOOGLE_API_KEY,
    libraries: 'places'
  }
})

export default {
  name: 'google-map',

  mixins: [NumberMixins],

  props: {

    lat: {
      type: [String, Number],
      required: true
    },

    lng: {
      type: [String, Number],
      required: true
    },

    markers: {
      type: Array,
      default: null
    },

    addMarkers: {
      type: Boolean,
      default: false
    },

    deleteMarkers: {
      type: Boolean,
      default: false
    },

    dragMarkers: {
      type: Boolean,
      default: true
    },

    width: {
      type: String,
      default: '100%'
    },

    height: {
      type: String,
      default: '321px'
    },
/*
roadmap
satellite
hybrid
terrain
*/
    mapType: {
      type: String,
      default: 'hybrid'
    },

    mapStyle: {
      type: Array,
      default: null
    },

    zoom: {
      type: Number,
      default: 15
    },

    scrollable: {
      type: Boolean,
      default: false
    },

    draggable: {
      type: Boolean,
      default: false
    },

    clickable: {
      type: Boolean,
      default: true
    },

    showNominal: {
      type: Boolean,
      default: false
    },

    showMapType: {
      type: Boolean,
      default: true
    },

    options: {
      type: Array,
      ddefault: null
    },

    optionMapPins: {
      type: Array,
      ddefault: null
    },

    optionIcons: {
      type: Array,
      ddefault: null
    }

  },



  methods: {

    resetBounds () {
      if (window.google) {
        this.bounds = new window.google.maps.LatLngBounds()
      } else {
        console.error('window doesn\'t have google prop.', window)
      }

    },


    updatePos (e) {

      if (!e.latLng) {
        console.error('Invalid e.latLng', e)
        return
      }

      let lat = e.latLng.lat()
      let lng = e.latLng.lng()

      if (this.isNumber(lat) && this.isNumber(lng)) {

         this.localLat = lat
         this.localLng = lng

         let p = {lat: this.localLat, lng: this.localLng}

         this.$emit('update', p)
         }
    },

    updateMarkerPos (e) {

      if (!e.latLng) {
        console.error('Invalid e.latLng', e)
        return
      }

      let lat = e.latLng.lat()
      let lng = e.latLng.lng()

      if (this.isNumber(lat) && this.isNumber(lng)) {

         this.dragLat = lat
         this.dragLng = lng

         if (!this.index) {
            this.$message('Click on the marker to save lat/lng')
         }
      }

    },


    markerDrag (ind) {

      if (!this.dragLat || !this.dragLng) {
        console.error('Invalid drag lat/lng - for marker: ', ind)
        return
      }

      this.index = ind

      this.mrk[this.index].position.lng = this.dragLng
      this.mrk[this.index].position.lat = this.dragLat

      var p = this.mrk[this.index].position

      this.mrk[this.index].distance = this.roundTo(
        this.distanceInKmBetween(this.localLat, this.localLng, p.lat, p.lng) * 1000
        , 2)

      this.$emit('changed', this.index, this.mrk[this.index])
      this.index = null

    },


    defaultMapPin () {
      return 'static/map/marker.png'
    },

    nominalMapPin () {
      return 'static/map/blue-cross-hairs-map.png'
    },


    position (pos) {
      if (pos.lat && pos.lng) {
        return {lat: Number(pos.lat), lng: Number(pos.lng)}
      } else {
        return null
      }
    },


    typeIcon (type) {
      let i = this.arrayFindIndex(this.options, type)
      return (i >= 0 ? this.optionIcons[i] : null)
    },


    toggleAdd () {

      if (this.adding) {
        this.mrk.push(this.clone(this.marker))
        this.marker = {infoText: null, type: null, position: {lat: this.lat, lng: this.lng}}
      }

      this.adding = !this.adding
      this.item = (this.adding ? 'addMarker' : 'table')
    },


    handleEdit (ind, row) {
        console.log('EDIT ind', ind, row)
    },


    handleDelete (ind, row) {

      this.$confirm('This will permanently marker: ' + row.infoText + '. Continue?', 'Warning', {
               confirmButtonText: 'OK',
               cancelButtonText: 'Cancel',
               type: 'danger'
             })
             .then(() => {

               this.mrk = this.arrayRemoveIndex(this.mrk, ind)

               this.$message({
                 type: 'success',
                 message: 'Delete completed'
               })
             })
             .catch(() => {
               this.$message({
                 type: 'info',
                 message: 'Delete canceled'
               })
             })
    }
  },



  computed: {

    mapPosition: function () {
      if (this.localLat && this.localLng) {
        return {lat: Number(this.localLat), lng: Number(this.localLng)}
      } else {
        return null
      }
    }

  },


  watch: {

    lat: function (lat) {
      this.localLat = lat
    },

    lng: function (lng) {
      this.localLng = lng
    },

    addMarkers: function (ad) {
      this.canAdd = ad
      this.adding = this.canAdd ? this.adding : false
      this.item = (this.adding ? 'addMarker' : 'table')
    }

  },



  data () {

    return {
      key: GOOGLE_API_KEY,
      mapRef: 'atomMap' + Date.now(),

      localLat: Number(this.lat),
      localLng: Number(this.lng),
      bounds: null,

      mrk: this.markers,

      dragLat: null,
      dragLng: null,

      index: null,
      item: 'table',
      canAdd: this.addMarkers,
      adding: false,

      marker: {infoText: null, type: null, position: {lat: this.lat, lng: this.lng}},

      hasMarkers: this.markers ? true : false,

      mapOptions: {
        scrollwheel: this.scrollable,
        mapTypeControl: this.showMapType,
        styles: this.mapStyle
      }

    }

  },

  created () {

    if (this.markers) {

      this.resetBounds ()

      for (let i = 0; i < this.markers.length; i++) {

        if (this.bounds) {
          this.bounds.extend(this.markers[i].position)
        }

      }  // for

    }
  },

  mounted () {

    if (this.bounds) {
      this.$refs[this.mapRef].fitBounds(this.bounds)
    }

  }


}

</script>
